(() => {
  // The store locator app replaces these labels after the theme has loaded.
  const labels = [
    ['#page-header .bh-sl-title', 'Find our stores'],
    ['label[for="bh-sl-address"]', 'Current location'],
    ['button#scapl-geocode-btn', 'Find my location'],
    ['label[for="scasl-radius-container"]', 'Search radius'],
    ['label[for="scasl-lengthUnit"]', 'Distance unit'],
    ['label[for="scasl-tag-list-container"]', 'Tags'],
    ['.scasl-see-more', 'More »'],
    ['.scasl-see-less', 'Less «'],
    ['#bh-sl-submit', 'Search'],
    ['#scasl-tabs .scasl-tab-list', 'List'],
    ['#scasl-tabs .scasl-tab-map', 'Map'],
    ['#scasl-lengthUnit option[value="km"]', 'Kilometres'],
    ['#scasl-lengthUnit option[value="m"]', 'Miles'],
  ];

  function translate() {
    const root = document.getElementById('scasl-app-container');
    if (!root) return;

    labels.forEach(([selector, english]) => {
      const element = root.querySelector(selector);
      if (element && element.textContent.trim() !== english) {
        element.textContent = english;
      }
    });

    const address = root.querySelector('#bh-sl-address');
    if (address && address.placeholder !== 'Enter a location') {
      address.placeholder = 'Enter a location';
    }
  }

  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      translate();
    });
  });

  // The app can replace the entire container, so observe its stable parent.
  observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  translate();
})();
